import { FinanceAccountMainContainer } from '../../../containers';

export const FinanceAccountMain = () => {
  return <FinanceAccountMainContainer />;
};
